import {reactive, computed, ref, watch} from "vue";
import {useRouter} from "vue-router";
import emailjs from "emailjs-com";
import {useStore} from "vuex";
import useQueryBuilder from "@/modules/moduleA/helpers/useQueryBuilder";
import useResultsPriceArray from "@/modules/moduleA/helpers/useResultsPriceArray";


export default function(){
  const router = useRouter()
  const store = useStore()
  const {} = useQueryBuilder()
  const results = computed(() => {
    return store.state.moduleA.results
  })
  const {priceArray} = useResultsPriceArray()

  const form = reactive({
    trouble: {value:null, required: true },
    name: {value: null, required: true},
    nameFurigana: {value: null, required: true},
    partnerName: {value: null, required: false},
    partnerFurigana: {value: null, required: false},
    postcode: {value: null, required: true},
    city: {value: null, required: true},
    address: {value: null, required: true},
    tel: {value: null, required: true},
    email: {value: null, required: true},
    email2: {value: null, required: true},
    enrollmentDate: {value: null, required: false, year:null, month:null, day:null},
    weddingDate: {value: null, required: false, year:null, month:null, day:null},
    gauge: {value: null, check: null, required: false},
    boxType: {value: null, required: false},
    paymentType: {value: null, required: false},
    deliveryDate: {value: null, required: false},
    comment: {value:null, required:false,},
    todayDate: {value: null, required: false},
    result: {base:null, shape:null, texture:null, surface:null, width:null, milgrain:null, outsideDia:null, outsideDiaOption:null, insideDia:null, ringText:null, ringTextOption:null, ringSize:null, userId:null, location:null, price:null, required:false},
  })
  const formElement = ref(null)
  const invalids = ref([])

  const cities = (["北海道","青森県","岩手県","宮城県","秋田県","山形県","福島県",
    "茨城県","栃木県","群馬県","埼玉県","千葉県","東京都","神奈川県",
    "新潟県","富山県","石川県","福井県","山梨県","長野県","岐阜県",
    "静岡県","愛知県","三重県","滋賀県","京都府","大阪府","兵庫県",
    "奈良県","和歌山県","鳥取県","島根県","岡山県","広島県","山口県",
    "徳島県","香川県","愛媛県","高知県","福岡県","佐賀県","長崎県",
    "熊本県","大分県","宮崎県","鹿児島県","沖縄県"
  ])

  const years = ref([])
  const date =  new Date();
  const year = date.getFullYear();
  const months = ref([])
  const days = ref([])
  for (let i = year; i <= year+10; i++){
    years.value.push(i+"年")
  }
  for (let i = 1; i <= 12; i++){
    months.value.push(i+"月")
  }
  for (let i = 1; i <= 31; i++){
    days.value.push(i+"日")
  }

  // today's date
  const todayMonth = date.getMonth()+1;
  const todayDay = date.getDate();
  const todayDateVal = year + "/" + todayMonth+ "/" + todayDay
  const gauge = ref(["#1", "#2", "#3"])

  const changeActiveButton = (type, key) => {
    form[key].value = type
  }
  
  // シミュレーションの結果とurlをフォームに送る
  const resultsStep1 = results.value.find(item => {
    return item.step === 1
  })
  const resultsStep2 = results.value.find(item => {
    return item.step === 2
  })
  const resultsStep3 = results.value.find(item => {
    return item.step === 3
  })
  const resultsStep4 = results.value.find(item => {
    return item.step === 4
  })
  const resultsStep5 = results.value.find(item => {
    return item.step === 5
  })
  const resultsStep6 = results.value.find(item => {
    if(item.step === 6){
      return item.step === 6
    }
  })
  const resultsStep7 = results.value.find(item => {
    if(item.step === 7){
      return item.step === 7
    }
  })
  const resultsStep8 = results.value.find(item => {
    if(item.step === 8){
      return item.step === 8
    }
  })
  const resultsStep9 = results.value.find(item => {
    if(item.step === 9){
      return item.step === 9
    }
  })
  const resultsStep10 = results.value.find(item => {
    if(item.step === 10){
      return item.step === 10
    }
  })

  let resultsObj = {}
  resultsObj["step1"] = resultsStep1.name
  resultsObj["step2"] = resultsStep2.name
  resultsObj["step3"] = resultsStep3.name
  resultsObj["step4"] = resultsStep4.name
  resultsObj["step5"] = resultsStep5.name
  if(resultsStep6) {
    resultsObj["step6"] = resultsStep6.name
  }
  if(resultsStep7) {
    resultsObj["step7"] = resultsStep7.name
    if(resultsStep7.option) {
      resultsObj["step7Option"] = resultsStep7.option
    }
  }
  if(resultsStep8) {
    resultsObj["step8"] = resultsStep8.name
  }
  if(resultsStep9) {
    resultsObj["step9"] = resultsStep9.name
    if(resultsStep9.option) {
      resultsObj["step9Option"] = resultsStep9.option
    }
  }
  resultsObj["step10"] = resultsStep10.name


  let currentLocation = window.location.href
  currentLocation = currentLocation.replace( '/form?', '/step11?' );
  resultsObj["location"] = currentLocation


  let userIdVal = ""
  const queryStr = window.location.search.slice(1) // 文頭?を除外
  // クエリ文字列を & で分割して処理
  queryStr.split('&').forEach(function(queryStr) {
    // = で分割してkey,valueをオブジェクトに格納
    let queryArr = queryStr.split('=');
    if(queryArr[0] === "userId") {
      userIdVal = queryArr[1]
    }
  });
  resultsObj["userId"] = userIdVal


  // 金額を3桁でコンマ
  function priceSeparate(num){
    return String(num).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
  }
  const totalPrice = priceSeparate(priceArray.reduce((sum, element) => sum + element, 0));
  resultsObj["price"] = totalPrice


  watch(() => form.postcode.value, (val) => {
    if (val.length === 7){
      new window.YubinBango.Core(val, (addr) => {
        form.city.value = addr["region"]
        form.address.value = addr["l"] + " " +addr["m"] + " " + addr["o"]
      })
    }
  })

  watch(() => form.enrollmentDate.value, (val) => {
    if (val){
      form.enrollmentDate.year = null
      form.enrollmentDate.month = null
      form.enrollmentDate.day = null
    }
  })

  watch(() => form.weddingDate.value, (val) => {
    if (val){
      form.weddingDate.year = null
      form.weddingDate.month = null
      form.weddingDate.day = null
    }
  })

  function extractAndValidateRequiredItems(object){
    const keys = Object.keys(object)
    const values = Object.values(object)
    let indexes = []
    values.forEach((value, idx) => {
      if (!value || !value.length){
        indexes.push(idx)
      }
    })
    return keys.filter((key, idx) => {
      return indexes.includes(idx)
    })
  }

  const submit = (e, type) => {
    let enrollmentDateY = form.enrollmentDate.year;
    let enrollmentDateM = form.enrollmentDate.month;
    let enrollmentDateD = form.enrollmentDate.day;
    let weddingDateY = form.weddingDate.year;
    let weddingDateM = form.weddingDate.month;
    let weddingDateD = form.weddingDate.day;


    if(enrollmentDateY == null) {
      enrollmentDateY = ""
    }
    if(enrollmentDateM == null) {
      enrollmentDateM = ""
    }
    if(enrollmentDateD === null) {
      enrollmentDateD = ""
    }
    if(weddingDateY == null) {
      weddingDateY = ""
    }
    if(weddingDateM == null) {
      weddingDateM = ""
    }
    if(weddingDateD == null) {
      weddingDateD = ""
    }


    const templateType = type === 1 ? "template_p2m5yd8" : 
                         type === 2 ? "template_z8dbhrt" : 
                         type === 3 ? "template_ghruj4l" : ""


    const requreTemplate1 = {
      name: form.name.value, nameFurigana: form.nameFurigana.value,
      postcode: form.postcode.value, city: form.city.value, address: form.address.value,
      tel: form.tel.value, email: form.email.value,
    }
    const requreTemplate2 = {
      name: form.name.value, nameFurigana: form.nameFurigana.value,
      email: form.email.value,
    }
    const requreTemplate3 = {
      name: form.name.value, nameFurigana: form.nameFurigana.value,
      tel: form.tel.value, email: form.email.value,
    }

    const requreTemplate = type === 1 ? requreTemplate1 : 
                            type === 2 ? requreTemplate2 : 
                            type === 3 ? requreTemplate3 : ""


    const template = {
      trouble: form.trouble.value,
      name: form.name.value, nameFurigana: form.nameFurigana.value,
      partnerName: form.partnerName.value, partnerFurigana: form.partnerFurigana.value,
      postcode: form.postcode.value, city: form.city.value, address: form.address.value,
      tel: form.tel.value, email: form.email.value,
      enrollmentDate: form.enrollmentDate.value ? form.enrollmentDate.value : enrollmentDateY+"/"+enrollmentDateM+"/"+enrollmentDateD,
      weddingDate: form.weddingDate.value ? form.weddingDate.value : weddingDateY+"/"+weddingDateM+"/"+weddingDateD,
      deliveryDate: form.deliveryDate.value,
      gauge: form.gauge.value, gaugeCheck: form.gauge.check,
      boxType: form.boxType.value, paymentType: form.paymentType.value,
      comment:form.comment.value,
      todayDate: todayDateVal,
      resultsBase: resultsObj.step1, resultsShape: resultsObj.step2, resultsTexture: resultsObj.step3, resultsSurface: resultsObj.step4, 
      resultsWidth: resultsObj.step5, resultsMilgrain: resultsObj.step6, resultsOutsideDia: resultsObj.step7, resultsOutsideDiaOption: resultsObj.step7Option, 
      resultsInsideDia: resultsObj.step8, resultsRingText: resultsObj.step9, resultsRingTextOption: resultsObj.step9Option, resultsRingSize: resultsObj.step10, 
      resultsUserId: resultsObj.userId, resultsLocation: resultsObj.location, resultsPrice: resultsObj.price,
    }

    invalids.value = extractAndValidateRequiredItems(requreTemplate)


    if (!invalids.value.length){
      document.getElementById("overlay").classList.add("active");
      
      emailjs.send('service_atelier-tamari', templateType, template, 'user_uYIUEDpfCqOVbkiGMIiq0')
        .then((result) => {
          console.log('SUCCESS!', result.status, result.text);
          document.getElementById("overlay").classList.remove("active");
          router.push({ path: 'thankyou' })
        }, (error) => {
          document.getElementById("overlay").classList.remove("active");
          console.log('FAILED...', error);
        });
      // console.log('service_atelier-tamari', templateType, template, 'user_uYIUEDpfCqOVbkiGMIiq0')
      // document.getElementById("overlay").classList.remove("active");
        
    } else {
      formElement.value.parentElement.scrollTo({top:400, left:0, behavior:"smooth"})
    }
      
  }

  return {form, cities, years, months, days, formElement, invalids, gauge, changeActiveButton, submit}
}
